<template>
  <div class="main-wrapper">
    <GymRegister />
  </div>
</template>

<script>
import GymRegister from "@/components/molecules/GymRegister.vue";

export default {
  components: {
    GymRegister,
  },
  data() {
    return {
      ranges: [1, 5, 10],
    };
  },
};
</script>

<style lang="scss">
@media only screen and (max-width: 813px) {
  .header-1 {
    font-size: 3rem !important;
  }
}

.home-wrapper {
  margin: 2rem;
}

.main-wrapper {
  margin: auto;
  width: 90%;
  min-height: 100vh;
}
</style>
